<div class="AmBagsTable">
  <div class="AmBagsTable-content">
    <!-- table header -->
    <div class="AmBagsTable-header">
      <div class="th text-capitalize">
        {{ "bagsSelection.table.headers.passenger" | translate | titlecase}}
      </div>
      <div *ngIf="hasRedeeme" class="th thRedeem">
      </div><!-- beneficio -->
      <div
        class="th"
        *ngIf="isReviewBags"
      >
        <span>{{ "bagsSelection.table.headers.bagsPayment" | translate | titlecase }}</span>
      </div>
      <div *ngIf="hasBags32Kg" class="th text-capitalize">
        <span>{{ "bagsSelection.table.headers.bags32Kg" | translate | titlecase}}</span>
        <img src="./assets/images/bags/icon-bag-header-premier.svg" />
      </div>
      <div *ngIf="hasBags20Kg" class="th text-capitalize">
        <span>{{ "bagsSelection.table.headers.bags20Kg" | translate | titlecase }}</span>
      </div>
      <div *ngIf="hasBags25Kg" class="th text-capitalize">
        <span>{{ "bagsSelection.table.headers.bags25Kg" | translate | titlecase }}</span>
      </div>
      <div class="th text-capitalize">
        <span>{{ "bagsSelection.table.headers.price" | translate | titlecase }}</span>
      </div>
    </div>
    <!-- table body -->
    <app-am-scroll  [height]="270">
      <div class="AmBagsTable-body">
        <div *ngFor="let item of passengers" class="tr">
          <div class="td" [ngClass]="{ 'tdHasRedeem' : item.hasRedeeme }">
            <am-bags-passenger class="w-100"
              [passenger]="item"
            >
            </am-bags-passenger>
          </div>
          <div *ngIf="hasRedeeme" class="td">
            <am-bag-redeemed *ngIf="item.hasRedeeme || item.hasRedeemed"
              [active]="item.hasRedeemed"
              (onRedeeme)="onRedeemed($event , item)"
            ></am-bag-redeemed>
          </div>
          <div
            class="td"
            *ngIf="isReviewBags"
          >
            <am-bags-payment
              [bags20kg]="item.bagsPrePaid(BagsWeight._20KG)"
              [bags25kg]="item.bagsPrePaid(BagsWeight._25KG)"
              [bags32kg]="item.bagsPrePaid(BagsWeight._32KG)"
            ></am-bags-payment>
          </div>
          <div *ngIf="hasBags32Kg" class="td">
            <am-counter
              (handleCount)="handleCountBags($event)"
              (minus)="item.onMinusBag($event, BagsWeight._32KG)"
              (plus)="item.onPlus32kg($event)"
              [count]="item.bags32Kg"
              [enablePlus]="item.availableBagsAdd(BagsWeight._32KG)"
            >
            </am-counter>
          </div>
          <div *ngIf="hasBags20Kg" class="td">
            <am-counter
              (handleCount)="handleCountBags($event)"
              (minus)="item.onMinusBag($event, BagsWeight._20KG)"
              (plus)="item.onPlus20kg($event)"
              (onPlusLimit)="handleOpenModal20kg()"
              [count]="item.bags20Kg"
              [enablePlus]="item.availableBagsAdd(BagsWeight._20KG)"
            >
            </am-counter>
          </div>
          <div *ngIf="hasBags25Kg" class="td">
            <am-counter
              (handleCount)="handleCountBags($event)"
              (minus)="item.onMinusBag($event, BagsWeight._25KG)"
              (plus)="item.onPlus25kg($event,extraBags,isDomestic)"
              [count]="item.bags25Kg"
              [enablePlus]="item.availableBagsAdd(BagsWeight._25KG)"
            >
            </am-counter>
          </div>
          <div class="td">
            <am-bag-status
            [currencyCode]= "item.getCurrencyCodeBagsToPay"
            [statusBag]="getStatusBagColumnPassenger(item)"
            [totalAmount]="item.getTotalAmountBagColumn"
            >
          </am-bag-status>
          </div>
        </div>
      </div>
    </app-am-scroll>

  </div>
  <!-- table footer -->
  <div class="AmBagsTable-footer">
    <div class="tf">
      <div class="container-info-footer">
        <img
          src="./assets//images/bags/icon-bag-footer.svg"
          alt="footer-bags"
        />
        <span>{{ "bagsSelection.table.footer.passenger" | translate }}</span>
      </div>
    </div>
    <div *ngIf="hasRedeeme" class="tf"></div><!-- beneficio -->
    <div *ngIf="isReviewBags" class="tf">
      <am-bags-footer-resume
        [totalBags]="(this.bags20KGPaid?.length + this.bags25KGPaid?.length + this.bags32KGPaid?.length)"
      ></am-bags-footer-resume>
    </div>
    <div *ngIf="hasBags32Kg" class="tf">
      <am-bags-footer-count-bags
        [bagWeight]="BagsWeight._32KG"
        [count]="totalBagsForWeight(BagsWeight._32KG)"
      ></am-bags-footer-count-bags>
    </div>
    <div *ngIf="hasBags20Kg" class="tf">
      <am-bags-footer-count-bags
        [bagWeight]="BagsWeight._20KG"
        [count]="totalBagsForWeight(BagsWeight._20KG)"
      ></am-bags-footer-count-bags>
    </div>
    <div *ngIf="hasBags25Kg" class="tf">
      <am-bags-footer-count-bags
        [bagWeight]="BagsWeight._25KG"
        [count]="totalBagsForWeight(BagsWeight._25KG)"
      ></am-bags-footer-count-bags>
    </div>
    <div class="tf status-global" [ngSwitch]="statusGlobalBags">
      <span *ngSwitchCase="StatusBag.NONE">
        {{'bagsSelection.bag-status.none' | translate}}
      </span>
      <span *ngSwitchCase="StatusBag.INCLUDE">
        {{'bagsSelection.bag-status.include' | translate}}
      </span>
      <span class="d-flex gap-1" *ngSwitchCase="StatusBag.PAID">
        <img src="./assets/images/bags/icon-bag-check.svg" alt="">
        {{'bagsSelection.bag-status.paid' | translate}}
      </span>
      <span *ngSwitchCase="StatusBag.REDEEMED_APPLIED">
        {{'bagsSelection.bag-status.redeemedAplied' | translate}}
      </span>
      <div *ngSwitchCase="StatusBag.TO_PAY">
        <strong>{{totalAmountBags | amCurrency:'':'symbol':'0.0'}} </strong>
        <span>{{currencyCodeBags}}</span>
      </div>
    </div>
  </div>
  <div class="mt-2 d-flex gap-2 " *ngIf="hasRedeeme">
    <img src="./assets/images/bags/icon-bag-gift-success.svg" alt="">
    <span>{{'bagsSelection.table.footer-extas.redeem' | translate}}</span>
  </div>
</div>
